import Icon from 'veui/components/Icon'
import { IconUnlock } from 'dls-icons-vue'

Icon.register('unlock', IconUnlock)
